import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, staggerWrap } from '../../motion';
import { homepageContent } from '../../data/products';
import Icon from '../Icon/Icon';
import './StatsBanner.css';

const StatsBanner = () => {
  const content = homepageContent.orderFacts;
  const stats = content.items;

  return (
  <section className="stat-banner" aria-label="Ordering information">
    <div className="stat-inner">
      <motion.div
        className="stat-grid"
        variants={staggerWrap(0.1, 0.04)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.35 }}
      >
        {stats.map((item) => (
          <motion.div
            className="stat-item"
            key={item.value}
            variants={fadeUp(0, 18)}
          >
            <Icon name={item.icon} size={20} strokeWidth={1.5} />
            <div>
              <div className="stat-n">{item.value}</div>
              <div className="stat-l">{item.label}</div>
            </div>
          </motion.div>
        ))}
      </motion.div>
      <a className="stat-cta" href={`#${content.ctaTarget}`}>
        {content.ctaLabel}
        <Icon name="arrow" size={16} strokeWidth={1.8} />
      </a>
    </div>
  </section>
  );
};
export default StatsBanner;
